import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  CHECKLIST_ANSWER,
  HOW_STEPS,
  REPORT_SECTIONS,
  calculateReportScore,
  getDefaultAnswers,
} from './reportChecklistLogic';
import '../TargetAudit/TargetAudit.css';
import './ReportChecklist.css';

const ANSWER_LABELS = {
  yes: 'Есть',
  partial: 'Частично',
  no: 'Нет',
};

const ANSWER_OPTIONS = [CHECKLIST_ANSWER.YES, CHECKLIST_ANSWER.PARTIAL, CHECKLIST_ANSWER.NO];

const ReportChecklist = () => {
  const [answers, setAnswers] = useState(getDefaultAnswers);
  const resultsRef = useRef(null);
  const wasCompleteRef = useRef(false);
  const result = useMemo(() => calculateReportScore(answers), [answers]);

  const handleReset = () => {
    setAnswers(getDefaultAnswers());
    wasCompleteRef.current = false;
  };

  useEffect(() => {
    if (result.isComplete && !wasCompleteRef.current) {
      resultsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    wasCompleteRef.current = result.isComplete;
  }, [result.isComplete]);

  return (
    <div className="ta-tool rc-tool">
      <div className="ta-toolbar">
        <span className="ta-progress">
          {`Отвечено: ${result.answeredCount} из ${result.totalCount}`}
        </span>
        <button type="button" className="ta-reset-btn" onClick={handleReset}>
          {'Сбросить всё'}
        </button>
      </div>

      {REPORT_SECTIONS.map((section) => (
        <div key={section.id} className="ta-section">
          <div className="ta-panel-title">{section.title}</div>
          {section.items.map((item) => (
            <div key={item.id} className="ta-item">
              <div className="ta-item-text">
                <div className="ta-item-title">{item.title}</div>
                <div className="ta-item-hint">{item.hint}</div>
              </div>
              <div className="ta-answers">
                {ANSWER_OPTIONS.map((option) => (
                  <button
                    key={option}
                    type="button"
                    className={`ta-answer-btn${answers[item.id] === option ? ' ta-answer-btn--active' : ''} ta-answer-btn--${option}`}
                    onClick={() => setAnswers((prev) => ({ ...prev, [item.id]: option }))}
                  >
                    {ANSWER_LABELS[option]}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}

      {result.answeredCount > 0 ? (
        <div ref={resultsRef} className="ta-results">
          <div className="ta-score-panel">
            <div className="ta-score-main">
              <div className="ta-score-label">{'Готовность к запуску'}</div>
              <div className="ta-score-value">{result.percent}%</div>
              <div className="ta-score-bar">
                <div className="ta-score-bar-fill" style={{ width: `${result.percent}%` }} />
              </div>
              <p className="ta-score-status">{result.status}</p>
            </div>
            <p className="ta-score-hint">{'Ответьте на все пункты. «Частично» = 50% балла за пункт.'}</p>
          </div>

          {result.isComplete && result.questions.length > 0 ? (
            <div className="rc-questions-panel">
              <div className="ta-panel-title">{'Спросить у подрядчика'}</div>
              <ul className="ta-gaps-list">
                {result.questions.map((question) => (
                  <li key={question}>{question}</li>
                ))}
              </ul>
            </div>
          ) : null}

          {result.isComplete && result.questions.length === 0 ? (
            <div className="rc-questions-panel rc-questions-panel--ok">
              <p>{'Отчёт полный — дополнительных вопросов по чеклисту нет.'}</p>
            </div>
          ) : null}
        </div>
      ) : null}

      <div className="ta-how">
        <div className="ta-panel-title">{'Как считается'}</div>
        {HOW_STEPS.map((step) => (
          <div key={step.num} className="ta-how-step">
            <div className="ta-how-num">{step.num}</div>
            <div className="ta-how-text">
              <strong>{step.title}</strong> {step.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportChecklist;
